import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-documentation.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-documentation.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../app-controller.service";
import { ApplicationCreateService } from "../shared/application-create.service";
import { CreateApplicationConstants } from "../shared/create-application.constants";
import { AlertType } from "../../shared/models/alert";
import { BehaviorSubject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DeleteDocumentsConfirmationDialogComponent } from "../shared/forms/delete-documents-confirmation-dialog/delete-documents-confirmation-dialog.component";
import { AddDocumentsDialogComponent } from "../shared/forms/add-documents-dialog/add-documents-dialog.component";
import { DatePipe } from "@angular/common";
import { EditDocumentsDialogComponent } from "../shared/forms/edit-documents-dialog/edit-documents-dialog.component";
import { AppConfig } from "../../app.config";
import { Validators } from "@angular/forms";
import { CreateApplicationViewBaseComponent } from "../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { CreateApplicationDocumentationConstants } from "./create-application-documentation.constants";
import { FileUtils } from "../../shared/utils/file-utils";
import { SearchApplicationsService } from "../../search-applications/shared/search-applications.service";
let CreateApplicationDocumentationComponent = class CreateApplicationDocumentationComponent extends CreateApplicationViewBaseComponent {
    aflaModuleStrategyService;
    applicationCreateService;
    selectedApplicationService;
    modalService;
    datePipe;
    changeDetectorRef;
    appController;
    searchApplicationsService;
    showNoRequiredDocumentText = false;
    showCheckBoxColumn = true;
    tableMapper;
    tableDataSource = new BehaviorSubject([]);
    documentForm;
    requiredDocuments = [];
    optionalDocuments = [];
    showOptionalDocuments = false;
    stepHeader = "";
    noRequiredDocumentText = CreateApplicationDocumentationConstants.NO_DOCUMENT_REQUIRED_MESSAGE;
    noRequiredDocumentsFoundErrMsg = CreateApplicationDocumentationConstants.NO_REQUIRED_DOCUMENTS_FOUND_MESSAGE;
    uploadRequiredDocumentLabel = CreateApplicationDocumentationConstants.UPLOAD_REQUIRED_DOC_LABEL;
    applicationDocumentsLabel = CreateApplicationDocumentationConstants.APPLICATIONS_DOCUMENTS_LABEL;
    addBtnLabel = CreateApplicationDocumentationConstants.ADD_DOCUMENTS_BTN_LABEL;
    editBtnLabel = CreateApplicationDocumentationConstants.EDIT_DOCUMENTS_BTN_LABEL;
    deleteBtnLabel = CreateApplicationDocumentationConstants.DELETE_DOCUMENTS_BTN_LABEL;
    attachmentLabel = CreateApplicationDocumentationConstants.ATTACHMENT_LABEL;
    downloadLabel = CreateApplicationDocumentationConstants.DOWNLOAD_LABEL;
    deleteDocumentLabel = CreateApplicationDocumentationConstants.DELETE_DOCUMENTS_LABEL;
    addDocumentsDialogTitle = CreateApplicationDocumentationConstants.ADD_DOCUMENTS_DIALOG_TITLE;
    modalBodyOptions = CreateApplicationDocumentationConstants.modalBodyOptions;
    componentName = CreateApplicationDocumentationConstants.COMPONENT_NAME;
    editDocumentsDialogTitle = CreateApplicationDocumentationConstants.EDIT_DOCUMENTS_DIALOG_TITLE;
    additionalApplicationTypeConstant = CreateApplicationDocumentationConstants.ADDITIONAL_APPLICATION_TYPE_CONSTANTS;
    isDocumentRequiredConstant = CreateApplicationDocumentationConstants.IS_DOCUMENT_REQUIRED;
    documentFormControlName = CreateApplicationDocumentationConstants.DOCUMENT_FORM_CONTROL_NAME;
    documentsFormControlName = CreateApplicationDocumentationConstants.DOCUMENTS_FORM_CONTROL_NAME;
    datePipeFormat = CreateApplicationDocumentationConstants.DATE_PIPE_FORMAT;
    requiredDocumentLookupConstant = CreateApplicationDocumentationConstants.REQUIRED_DOCUMENTS_HEADING_LOOKUP;
    uploadOptionalDocumentLabel = CreateApplicationDocumentationConstants.UPLOAD_OPTIONAL_DOC_LABEL;
    optionalDocumentsLabel = CreateApplicationDocumentationConstants.OPTIONAL_DOCUMENTS_LABEL;
    selectedApplicationApplicationTypes = [];
    selectedDocuments = [];
    documentTypes = [];
    configUploadSettings;
    currentApplication;
    applicationCreateServiceSubscription;
    applicationCreateServiceSelectModuleSubscription;
    getAttachmentContentSubscription;
    selectedApplicationSubscription2;
    constructor(aflaModuleStrategyService, applicationCreateService, selectedApplicationService, modalService, datePipe, changeDetectorRef, appController, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.applicationCreateService = applicationCreateService;
        this.selectedApplicationService = selectedApplicationService;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this.changeDetectorRef = changeDetectorRef;
        this.appController = appController;
        this.searchApplicationsService = searchApplicationsService;
        this.configUploadSettings = AppConfig.settings.uploadFile;
    }
    ngOnInit() {
        this.initForm();
        this.initializeColumnToObjectMapping();
        this.setupSubscribers();
    }
    loadMetadata(stepMeta) {
    }
    arrayReturned(documents) {
        this.selectedDocuments = documents;
    }
    onDeleteBtnClicked() {
        if (this.selectedDocuments.length === 0) {
            this.appController.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        const modalRef = this.modalService.open(DeleteDocumentsConfirmationDialogComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.deleteDocumentLabel;
        modalRef.componentInstance.documentsToDelete = this.selectedDocuments;
        modalRef.result.then((deletedDocuments) => {
            if (deletedDocuments) {
                const idsOfDocumentsToBeDeleted = this.selectedDocuments.map(document => {
                    return document.id;
                });
                const params = {
                    ids: idsOfDocumentsToBeDeleted,
                    moduleId: this.currentApplication.moduleId
                };
                this.applicationCreateServiceSubscription = this.applicationCreateService.deleteUploadDocumentsObservable(params).subscribe({
                    next: () => {
                        this.deleteSelectedDocsFromTable(idsOfDocumentsToBeDeleted);
                        this.updateDocumentChecklist();
                        this.updateFormControl();
                        this.selectedDocuments = [];
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Delete);
                    }
                });
            }
        });
    }
    onAddBtnClicked(event) {
        const evt = event.target;
        this.documentTypes = this.getDocumentTypes();
        const modalRef = this.modalService.open(AddDocumentsDialogComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.addDocumentsDialogTitle;
        modalRef.componentInstance.documentTypes = this.documentTypes;
        modalRef.componentInstance.configUploadSettings = this.configUploadSettings;
        modalRef.componentInstance.currentApplication = this.currentApplication;
        modalRef.componentInstance.selectedDocumentType = evt.innerHTML;
        modalRef.result.then((newDocument) => {
            if (newDocument) {
                this.addDocumentToTable(newDocument);
                this.updateDocumentChecklist();
                this.updateFormControl();
                this.selectedDocuments = [];
                this.changeDetectorRef.markForCheck();
            }
        });
    }
    onEditBtnClicked() {
        if (this.selectedDocuments.length === 0) {
            this.appController.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        if (this.selectedDocuments.length > 1) {
            this.appController.showMessage(SharedConstants.MORE_THAN_ONE_SELECTED, AlertType.Warning);
            return;
        }
        this.documentTypes = this.getDocumentTypes();
        const modalRef = this.modalService.open(EditDocumentsDialogComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.editDocumentsDialogTitle;
        modalRef.componentInstance.documentToEdit = this.selectedDocuments[0];
        modalRef.componentInstance.documentTypes = this.documentTypes;
        modalRef.componentInstance.currentApplication = this.currentApplication;
        modalRef.componentInstance.configUploadSettings = this.configUploadSettings;
        modalRef.result.then((resultObject) => {
            if (resultObject) {
                this.deleteSelectedDocsFromTable(resultObject.idsToDelete);
                this.addDocumentToTable(resultObject.editedDocument);
                this.updateDocumentChecklist();
                this.updateFormControl();
                this.selectedDocuments = [];
            }
        });
    }
    onDownloadAttachment(attachment) {
        const attachmentId = attachment.id;
        const fileName = attachment.fileName;
        this.getAttachmentContentSubscription = this.applicationCreateService.getAttachmentContent(attachmentId).subscribe({
            next: (attachmentContent) => {
                FileUtils.openFile(fileName, attachmentContent);
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = this.requiredDocumentLookupConstant;
    }
    getRequiredDocumentsLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and name eq 'RequiredDocument' and deleted eq false`,
            $expand: "attachment"
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                if (response && response.hasOwnProperty("value") && response.value.length > 0) {
                    const lookups = response.value;
                    this.onGetRequiredDocumentsLookupsCompleted(lookups);
                }
                else {
                    // this.appController.showMessage(this.noRequiredDocumentsFoundErrMsg, AlertType.Warning)
                    this.loadSavedAttachments(this.currentApplication.attachments);
                    this.updateDocumentChecklistOnInit(this.tableDataSource.value);
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    onGetRequiredDocumentsLookupsCompleted(lookups) {
        this.requiredDocuments = [];
        this.optionalDocuments = [];
        this.showOptionalDocuments = false;
        this.buildRequiredDocumentsObjects(lookups);
        this.sortRequiredDocumentsAlphabetically();
        // optional documents
        this.requiredDocuments.forEach((doc) => {
            if (doc.optionalUpload?.toLowerCase().trim() === "yes") {
                this.optionalDocuments.push(doc);
            }
        });
        if (this.optionalDocuments.length > 0) {
            this.showOptionalDocuments = true;
        }
        this.requiredDocuments = this.requiredDocuments.filter(docs => docs.optionalUpload?.toLowerCase() != "yes");
        if (this.currentApplication.attachments.length > 0) {
            this.loadSavedAttachments(this.currentApplication.attachments);
            this.updateDocumentChecklistOnInit(this.tableDataSource.value);
        }
        this.updateFormControl();
        this.changeDetectorRef.detectChanges();
    }
    buildRequiredDocumentsObjects(lookups) {
        lookups.forEach(lookup => {
            const content = JSON.parse(lookup.content);
            if (this.selectedApplicationApplicationTypes.length > 0) {
                this.selectedApplicationApplicationTypes.forEach((applicationType) => {
                    if (content.category && content.applicationType !== this.additionalApplicationTypeConstant
                        && content.required?.toLowerCase() === this.isDocumentRequiredConstant
                        && content.applicationType?.toLowerCase() === applicationType?.toLowerCase()) {
                        this.appendRequiredDocuments(lookup, content);
                    }
                });
            }
            else {
                if (content.category && content.applicationType !== this.additionalApplicationTypeConstant
                    && content.required?.toLowerCase() === this.isDocumentRequiredConstant) {
                    this.appendRequiredDocuments(lookup, content);
                }
            }
        });
        if (this.requiredDocuments.length > 0) {
            this.removeDuplicateDocuments();
        }
    }
    addDocumentToTable(document) {
        // adds new document into the table
        const documentsAlreadyOnTheTable = this.tableDataSource.value;
        if (documentsAlreadyOnTheTable.length > 0) {
            documentsAlreadyOnTheTable.push(document);
            this.tableDataSource.next([...documentsAlreadyOnTheTable]);
        }
        else {
            this.tableDataSource.next([document]);
        }
    }
    updateDocumentChecklist() {
        const docsInTable = this.tableDataSource.value;
        this.resetDocumentsChecklist();
        this.updateDocumentChecklistOnInit(docsInTable);
    }
    deleteSelectedDocsFromTable(idsOfDocumentsToBeDeleted) {
        const documentsAlreadyOnTheTable = this.tableDataSource.value;
        const newDocuments = [];
        documentsAlreadyOnTheTable.forEach((document) => {
            let deleteDocument = false;
            idsOfDocumentsToBeDeleted.forEach((documentIdOfDeletedDocument) => {
                if (document.id === documentIdOfDeletedDocument) {
                    deleteDocument = true;
                }
            });
            if (!deleteDocument) {
                newDocuments.push(document);
            }
        });
        this.tableDataSource.next([...newDocuments]);
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription2 = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            // gets the saved application by jobId (if it exists)
            if (application) {
                if (+this.jobId > 0) {
                    this.getApplicationAttachments(application);
                }
            }
        });
    }
    setupSubscribers() {
        this.getStepHeadingSubscribers();
        this.subscribeToSelectedApplication();
    }
    getStepHeadingSubscribers() {
        this.applicationCreateServiceSelectModuleSubscription = this.applicationCreateService.selectedModuleNameAsObservable.subscribe((modName) => {
            const header = `${CreateApplicationConstants.REQUIRED_DOCUMENTATION_HEADING}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRef.markForCheck();
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.documentFormControlName);
        form.clearValidators();
        this.documentForm = form;
    }
    loadSavedAttachments(attachments) {
        const attachmentsForTable = [];
        attachments.forEach((attachment) => {
            const attachmentObject = {
                id: attachment.id,
                type: attachment.attachmentType,
                name: attachment.description,
                dateUploaded: this.datePipe.transform(attachment.date, this.datePipeFormat),
                fileName: attachment.fileName,
                source: attachment.source
            };
            attachmentsForTable.push(attachmentObject);
        });
        this.tableDataSource.next(attachmentsForTable);
    }
    updateFormControl() {
        // mark form as valid if all required documents are uploaded
        let formIsValid = true;
        if (this.showNoRequiredDocumentText) {
            formIsValid = true;
        }
        this.requiredDocuments.forEach((document) => {
            if (document.uploaded === false) {
                formIsValid = false;
            }
        });
        if (formIsValid) {
            this.documentForm.get(this.documentsFormControlName).clearValidators();
        }
        else {
            this.documentForm.get(this.documentsFormControlName).addValidators(Validators.required);
        }
        this.documentForm.markAllAsTouched();
        this.documentForm.get(this.documentsFormControlName).updateValueAndValidity();
    }
    getApplicationAttachments(application) {
        // get the application's attachments
        const params = {
            jobId: application.jobId
        };
        this.applicationCreateService.getAttachments(params).subscribe({
            next: (response) => {
                application.attachments = response.value;
                this.getApplicationTypes(application);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    updateDocumentChecklistOnInit(attachmentsForTable) {
        if (this.requiredDocuments.length > 0 && attachmentsForTable.length > 0) {
            this.requiredDocuments.forEach((requiredDocument) => {
                attachmentsForTable.forEach((attachment) => {
                    if (requiredDocument.name?.toLowerCase().trim() === attachment.type?.toLowerCase().trim()) {
                        requiredDocument.uploaded = true;
                    }
                });
            });
        }
        if (this.optionalDocuments.length > 0 && attachmentsForTable.length > 0) {
            this.optionalDocuments.forEach((optionalDocument) => {
                attachmentsForTable.forEach((attachment) => {
                    if (optionalDocument.name?.toLowerCase().trim() === attachment.type?.toLowerCase().trim()) {
                        optionalDocument.uploaded = true;
                    }
                });
            });
        }
    }
    getDocumentTypes() {
        this.documentTypes = [this.additionalApplicationTypeConstant];
        const requiredTypes = this.requiredDocuments?.map(document => {
            return document.name;
        });
        requiredTypes.forEach((type) => {
            this.documentTypes.push(type);
        });
        const optionalTypes = this.optionalDocuments?.map(document => {
            return document.name;
        });
        optionalTypes.forEach((type) => {
            this.documentTypes.push(type);
        });
        this.documentTypes = this.documentTypes.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'accent' }));
        return this.documentTypes;
    }
    getApplicationTypes(application) {
        const jobId = +this.jobId;
        const moduleId = +this.appController.selectedModuleID;
        this.aflaModuleStrategyService.getApplicationTypes(jobId, moduleId).subscribe({
            next: (applicationTypes) => {
                this.selectedApplicationApplicationTypes = applicationTypes.value;
                this.currentApplication = application;
                this.getRequiredDocumentsLookups();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    sortRequiredDocumentsAlphabetically() {
        if (this.requiredDocuments.length > 0) {
            this.requiredDocuments?.sort((a, b) => a?.name.localeCompare(b.name));
        }
        else {
            this.showNoRequiredDocumentText = true;
        }
    }
    appendRequiredDocuments(lookup, content) {
        const fileName = lookup.attachment === null ? "" : lookup.attachment.fileName;
        this.requiredDocuments.push({
            id: lookup.id,
            uploaded: false,
            category: content.category,
            name: content.name,
            description: content.description,
            required: content.required,
            optionalUpload: content.optionalUpload,
            fileName,
            attachmentId: lookup.attachment === null ? 0 : lookup.attachment.id,
        });
    }
    resetDocumentsChecklist() {
        if (this.requiredDocuments.length > 0) {
            this.requiredDocuments.forEach((doc) => {
                doc.uploaded = false;
            });
        }
    }
    removeDuplicateDocuments() {
        // removes document objects that have the same 'name' property
        const uniqueRequiredDocuments = {};
        const distinctDocumentsArray = [];
        const optionalDocumentsArray = [];
        this.requiredDocuments.forEach((documentObject) => {
            if (!uniqueRequiredDocuments[documentObject.name]) {
                distinctDocumentsArray.push(documentObject);
                uniqueRequiredDocuments[documentObject.name] = true;
            }
        });
        this.requiredDocuments = distinctDocumentsArray;
        //get optional documents
        this.requiredDocuments.forEach((optionalDoc) => {
            if (optionalDoc.optionalUpload?.toLowerCase().trim() === "yes") {
                optionalDocumentsArray.push(optionalDoc);
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ApplicationCreateService },
        { type: SelectedApplicationService },
        { type: NgbModal },
        { type: DatePipe },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDocumentationComponent = __decorate([
    Component({
        selector: "app-create-application-documentation",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDocumentationComponent);
export { CreateApplicationDocumentationComponent };
